import { render, staticRenderFns } from "./BackInHistoryBtn.vue?vue&type=template&id=6ff08d02&scoped=true&"
import script from "./BackInHistoryBtn.vue?vue&type=script&lang=js&"
export * from "./BackInHistoryBtn.vue?vue&type=script&lang=js&"
import style0 from "./BackInHistoryBtn.vue?vue&type=style&index=0&id=6ff08d02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff08d02",
  null
  
)

export default component.exports